// NEW_FILE_JUSTIFIED: single source of truth for conditional field visibility, shared by FieldRenderer and ClaimApplicationWizard validation
import type { IFormField, IConditionalDetailValue } from '@/@types/policyFormTemplates';

/**
 * Returns true when a field should be shown given the current form values.
 * A field with no `conditionalOn` is always visible. When `conditionalOn` is set,
 * the field is visible only if the referenced field's value equals the expected value.
 * Parent `conditional_detail` values (objects with an `answer` key) are compared by their answer.
 */
export function isFieldConditionallyVisible(
  field: IFormField,
  values: Record<string, unknown>
): boolean {
  if (!field.conditionalOn) return true;

  const dependentValue = values[field.conditionalOn.fieldKey];
  const isConditionalDetail =
    typeof dependentValue === 'object' && dependentValue !== null && 'answer' in dependentValue;

  const checkValue = isConditionalDetail
    ? (dependentValue as IConditionalDetailValue).answer // AS_JUSTIFIED: runtime-narrowed — 'answer' key confirmed present above
    : dependentValue;

  return checkValue === field.conditionalOn.value;
}
